import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-12 py-6">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-sm text-gray-600">
            Desenvolvido por <span className="font-semibold text-gray-900">Rumos Diversos Lda.</span>
          </div>
          
          <div className="text-xs text-gray-500">
            © {new Date().getFullYear()} Infraestruturas de Portugal. Todos os direitos reservados.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
